import { SuperRealTypesConfig } from "@super-real/types";
import { handleErrorWithoutToast } from "../Common/helpers/handleError";

SuperRealTypesConfig.logError = (error) => {
  handleErrorWithoutToast(error);
};
